import React from 'react';

export default function SortChipRow({ label = 'Sort by', options, value, onChange, primaryColor }) {
  return (
    <div style={styles.row}>
      <span style={styles.label}>{label}</span>
      <div style={styles.chips}>
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              style={{
                ...styles.chip,
                ...(active
                  ? {
                      backgroundColor: primaryColor || '#0066cc',
                      borderColor: primaryColor || '#0066cc',
                      color: '#fff',
                    }
                  : {}),
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  row: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 12 },
  label: { fontSize: 12, fontWeight: 600, color: 'var(--muted-foreground)', textTransform: 'uppercase', letterSpacing: '0.04em', marginRight: 4 },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  chip: {
    border: '1px solid var(--border)',
    background: 'var(--card)',
    color: 'var(--foreground)',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
  },
};
